export default __webpack_public_path__ + "static/11-e8770eb1e17da071095b92890ab8a7e2.png";